module.exports = __webpack_public_path__ + "img/6.bcc62d6e.svg";